module.exports = __webpack_public_path__ + "img/NYI-Logo-White.be38c14a.svg";